import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-page-procedura',
  templateUrl: './page-procedura.component.html',
  styleUrls: ['./page-procedura.component.scss']
})
export class PageProceduraComponent implements OnInit {

  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public titlePage: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService
  ) { }

  ngOnInit(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).subscribe(resView => {
      this.block = resView[0];
      this.setDataFields(this.block);
      this.titlePage = this.helpersService.retriveLinkTagA(this.block.field_titolo, 'a').title;
    });
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < 0 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_dipartimento.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_PROCEDURA.DEPARTMENT',
          value: block.field_tassonomia_dipartimento,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_area_universita.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_PROCEDURA.UNIVERSITY_AREAS',
          value: block.field_tassonomia_area_universita,
          isArray: true
        }
      ]
    }
  }

}
